export const FROM_NUMBER = "+19145056771"
export const MESSAGE_PING = "https://virtualhangar.io/wp-content/uploads/2022/06/notification_sound.mp3"
export const MAX_MESSAGE_LENGTH_ON_DISPLAY = 120
export const API_URL = process.env.REACT_APP_DEVELOPMENT ? "http://localhost:1337/" : "https://sms.virtualhangar.io:1337/"
export const WS_URL = process.env.REACT_APP_DEVELOPMENT ? "ws://localhost:1337/" : "wss://sms.virtualhangar.io:1337/"
